import { Typography } from 'antd';
import styles from './infoTile.module.css';
import { ReactNode } from 'react';

type InfoTileType = {
  icon?: ReactNode;
  title?: string;
  subtitle: string | number;
  color: 'white' | 'black';
  variant: 'primary' | 'secondary'
};

const InfoTile = ({
  icon,
  subtitle,
  title,
  color = 'black',
  variant = 'primary'
}: InfoTileType) => {
  const { Text } = Typography;
  return (
    <div className={`${styles.tileLayout}`}>
      <div className={`${styles.conentLayout} ${styles[color]}`}>
        {icon}
        {title && <Text className={`${styles.title} ${styles[color]} ${styles[variant+'Title']}`}>{title}</Text>}
      </div>
      <Text className={`${styles.subtitle} ${styles[color]} ${styles[variant]}`}>
        {subtitle}
      </Text>
    </div>
  );
};

export default InfoTile;
